import React, { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';

import Tag from '../../tag';

import LogoMangerBouger from '../../assets/svg/logo-header.svg';

import headerStyles from './header.module.css';

const Header = () => {
  const [navigation, setNavigation] = useState(false);

  const handleNavigationClick = useCallback(
    event => {
      event.preventDefault();
      setNavigation(!navigation);
    },
    [navigation]
  );

  const handleTag = (event: React.MouseEvent<HTMLButtonElement>) => {
    const tag = event.currentTarget.getAttribute('data-tag');
    Tag.send(null, `Lien-${tag}`);
  };

  return (
    <header className={headerStyles.header}>
      {navigation}
     
      <div className={headerStyles.header__wrapper}>
        <div className={headerStyles.header__logo}>
          <a
              href="https://mangerbouger.fr/"
              className={headerStyles.linkMangerBouger}
              onClick={handleTag}
              data-tag="Accueil MangerBouger"
            >
              <LogoMangerBouger className={headerStyles.logo} />
            </a>
        </div>
        <div>
          <button className={headerStyles.header__button + ' ' + headerStyles.header__iconbars} onClick={handleNavigationClick}>
              <FontAwesomeIcon icon={faBars} size="2x" />
          </button>
        </div>
        {navigation && (
          <ul className={headerStyles.navigation} role="navigation">
            <li>
              <a href="/" onClick={handleNavigationClick}>
                <span className={headerStyles.closeIcon}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.48 6.37"><path stroke="#fff" strokeMiterlimit="10" d="M6.07.41L.4 5.99M.35.36l5.78 5.65"/></svg>
                </span>
              </a>
            </li>
            <li>
              <a href="/" onClick={handleNavigationClick}>
                <span className={headerStyles.underline}>Accueil</span>
              </a>
            </li>
            <li>
              <a
                href="https://www.mangerbouger.fr/manger-mieux/se-faire-plaisir-en-mangeant-equilibre/manger-equilibre-ca-veut-dire-quoi-et-comment-y-arriver/comment-faire-ses-courses-pour-composer-des-menus-varies-et-manger-equilibre"
                onClick={handleTag}
                data-tag="Manger même chose"
              >
                Comment faire ses courses pour composer des menus variés et manger équilibré&nbsp;?
                <span className={headerStyles.arrowIcon}>
                  <FontAwesomeIcon icon={faChevronRight} size="2x" />
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.mangerbouger.fr/manger-mieux/se-faire-plaisir-en-mangeant-equilibre/manger-equilibre-ca-veut-dire-quoi-et-comment-y-arriver/comment-varier-son-alimentation-sur-la-semaine"
                onClick={handleTag}
                data-tag="Varier alimentation"
              >
                Comment varier son alimentation sur la semaine&nbsp;? 
                <span className={headerStyles.arrowIcon}>
                  <FontAwesomeIcon icon={faChevronRight} size="2x" />
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.mangerbouger.fr/manger-mieux/bien-manger-sans-se-ruiner/bien-manger-en-preservant-la-planete-sans-se-ruiner-c-est-possible/les-aliments-economiques"
                onClick={handleTag}
                data-tag="Se régaler sans se ruiner"
              >
                Les aliments économiques
                <span className={headerStyles.arrowIcon}>
                  <FontAwesomeIcon icon={faChevronRight} size="2x" />
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.mangerbouger.fr/manger-mieux/bien-manger-sans-se-ruiner/bien-manger-en-preservant-la-planete-sans-se-ruiner-c-est-possible/manger-plus-durable-c-est-forcement-plus-cher"
                onClick={handleTag}
                data-tag="Petit budget"
              >
                Manger plus durable c’est forcément plus cher&nbsp;?
                <span className={headerStyles.arrowIcon}>
                  <FontAwesomeIcon icon={faChevronRight} size="2x" />
                </span>
              </a>
            </li>
            <li>
              <a
                href="https://www.mangerbouger.fr/Manger-mieux/Recettes"
                onClick={handleTag}
                data-tag="Toutes nos recettes"
              >
                Découvrez toutes nos recettes
                <span className={headerStyles.arrowIcon}>
                  <FontAwesomeIcon icon={faChevronRight} size="2x" />
                </span>
              </a>
            </li>
          </ul>
        )}
      </div>
    </header>
  );
};

export default Header;
